<div class="quill-editor-dialog">
  <h2 mat-dialog-title>Erweiterte Textbearbeitung</h2>
  
  <mat-dialog-content>
    <div class="editor-container">
      <quill-editor
        class="quill-editor"
        [(ngModel)]="htmlContent"
        [modules]="quillConfig"
        [sanitize]="false"
        [styles]="editorStyle"
        [theme]="'snow'"
        [placeholder]="'Geben Sie Ihren Text hier ein...'"
        (onContentChanged)="onContentChanged($event)">
      </quill-editor>
    </div>
    
    <!-- <div class="preview-section">
      <h3>Vorschau:</h3>
      <div class="preview-content" [innerHTML]="safePreview()"></div>
    </div> -->
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button (click)="clearHtmlContent()">Einfachen Text verwenden</button>
    <button mat-button (click)="onCancel()">Abbrechen</button>
    <button mat-button color="primary" (click)="onSave()" [disabled]="isEditorEmpty()">
      Speichern
    </button>
  </mat-dialog-actions>
</div>